export default __webpack_public_path__ + "static/media/AcornOffice_44.cac49ff6.png";